var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditGradient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 0.871,
    y2: 0.671,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#265df5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5dc9f0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit-line",
    d: "M14.1,4.249,11.907,2.043a.772.772,0,0,0-1.09,0L3.049,9.813,2.34,12.879a.77.77,0,0,0,.746.935.8.8,0,0,0,.16,0l3.094-.71L14.1,5.341A.775.775,0,0,0,14.1,4.249ZM5.968,12.43l-2.9.609.661-2.849,5.811-5.8L11.78,6.634ZM12.28,6.092,10.04,3.849l1.3-1.294,2.2,2.243Z",
    transform: "translate(-2.322 -1.817)",
    fill: "url(#linear-gradient)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EditGradient.54a224811a84286c62e936ff98dc7f55.svg";